import * as React from 'react';
import * as fp from 'lodash/fp';

const httpsfy = fp.replace("http:", "https:");
const getUrl = ({
    fileName,
    relativePath,
    cloudFrontDomain,
    fileFormat,
    size
}) => `${httpsfy(cloudFrontDomain)}/f_auto,w_${size}${relativePath}${fileName}.jpg`;

export default (props) => {
    const { size = 240, className = '', alt = '' } = props;

    const src = getUrl({...props});
    const src2x = getUrl({...props, size: size * 2});
    const src3x = getUrl({...props, size: size * 3});

    return (
        <img
            className={className}
            src={src}
            srcSet={`${src} 1x, ${src2x} 2x, ${src3x} 3x`}
            alt={alt}
            width={size}
        />
    );
}



// WEBPACK FOOTER //
// ./resources/modules/cars/rating/tires/views/Img.tsx